const userOutlineSVG  = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 width="57.645px" height="60.399px" viewBox="0 0 57.645 60.399" enable-background="new 0 0 57.645 60.399" xml:space="preserve">
<g id="Layer_1">
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
<path fill="#FFFFFF" d="M17.648,54.28c2.084-1.138,3.377-3.317,3.377-5.689v-5.519l-0.354-0.426
c-0.032-0.039-3.346-4.068-4.598-9.523l-0.138-0.606l-0.524-0.339c-0.735-0.477-1.178-1.272-1.178-2.133v-5.432
c0-0.711,0.303-1.375,0.854-1.872l0.506-0.457v-8.533L15.58,13.55c-0.006-0.036-0.457-3.72,2.138-6.68
C19.934,4.347,23.73,3.064,29,3.064c5.247,0,9.031,1.271,11.253,3.777c2.593,2.93,2.167,6.682,2.165,6.712l-0.014,8.733
l0.504,0.457c0.551,0.496,0.854,1.16,0.854,1.874v5.431c0,1.092-0.743,2.083-1.809,2.412l-0.763,0.234l-0.245,0.759
c-0.903,2.809-2.19,5.402-3.823,7.709c-0.403,0.566-0.793,1.068-1.127,1.453l-0.381,0.434v5.667c0,2.47,1.373,4.691,3.583,5.793
l11.778,5.89h6.668l-2.646-1.404c-0.031,0.027-0.063,0.056-0.093,0.083c-0.449-0.312-0.901-0.591-1.368-0.823l-12.971-6.484
c-1.164-0.582-1.887-1.752-1.887-3.054v-4.53c0.301-0.371,0.617-0.791,0.945-1.251c1.679-2.372,3.024-5.009,4.008-7.849
c1.94-0.921,3.193-2.855,3.193-5.038v-5.431c0-1.328-0.487-2.617-1.358-3.631v-7.148c0.079-0.796,0.361-5.283-2.886-8.983
C39.759,1.632,35.189,0,29,0c-6.191,0-10.762,1.632-13.586,4.854c-3.246,3.7-2.965,8.187-2.885,8.983v7.15
c-0.869,1.013-1.357,2.3-1.357,3.628v5.432c0,1.687,0.756,3.261,2.051,4.322c1.242,4.86,3.795,8.54,4.739,9.788v4.434
c0,1.25-0.683,2.397-1.779,2.998L4.07,58.197c-0.112,0.061-0.223,0.124-0.333,0.189l0.013,0.022l-0.33,0.176
c-0.168,0.108-0.336,0.222-0.502,0.342c-0.019-0.016-0.035-0.032-0.052-0.048L0,60.399h6.428L17.648,54.28z"/>
</g>
</svg>

`;

export default userOutlineSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/userOutlineSVG.js